import { Body, Box } from '@hover/blueprint';
import React from 'react';

const DescriptionOld: React.FC = () => (
  <Box mb={{ base: 800, tablet: '56px' }} flexDir="column">
    <Body mb={500}>
      By downloading and/or using the Software and Services (as defined below),
      you accept and agree to comply with these Terms of Use (alternatively
      referred to as the “Standard Terms and Conditions”), which will govern
      your use of the Software and Services.
    </Body>
    <Body>
      THESE TERMS OF USE CONSTITUTE A BINDING LEGAL AGREEMENT BETWEEN YOU AND
      HOVER. IF YOU DO NOT WISH TO BE BOUND BY THESE TERMS OF USE, DO NOT
      DOWNLOAD THE HOVER APP OR DO NOT USE THE SOFTWARE AND SERVICES.
    </Body>
  </Box>
);

export default DescriptionOld;
